import { useSyncExternalStore } from 'react';

function subscribe(onStoreChange: () => void) {
  window.addEventListener('online', onStoreChange);
  window.addEventListener('offline', onStoreChange);

  return () => {
    window.removeEventListener('online', onStoreChange);
    window.removeEventListener('offline', onStoreChange);
  };
}

function getSnapshot(): boolean {
  return navigator.onLine;
}

function getServerSnapshot(): boolean {
  return true;
}

/**
 * React hook — returns `true` when the browser is online.
 *
 * Built on `useSyncExternalStore` so the value is consistent across
 * concurrent renders and updates synchronously on `online`/`offline` events.
 */
export function useConnectionStatus() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
